/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetStationSvgFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected svg
 */
  svgUid: string;
}

export function getStationSvgFile(http: HttpClient, rootUrl: string, params: GetStationSvgFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getStationSvgFile.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('svgUid', params.svgUid, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/svg+xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getStationSvgFile.PATH = '/stations/{uid}/svg/{svgUid}/file';
